import React from 'react';
import { Appointments } from '@devexpress/dx-react-scheduler';
import { Popover } from '@mui/material';
import { FormTypes } from 'enums';
import useWorkScheduleCalendarContext from 'components/AddWorkSchedule/WorkScheduleCalendar/context/useWorkScheduleCalendarContext';
import WorkScheduleRangesForm from 'components/AddWorkSchedule/WorkScheduleCalendar/WorkScheduleRangesForm/WorkScheduleRangesForm';
import AppointmentContent from './AppointmentContent';

export default function DraftAppointment({
  data,
  durationType,
}: Pick<Appointments.AppointmentContentProps, 'data' | 'durationType'>) {
  const {
    draftAnchorEl,
    setDraftAnchorEl,
    handleRemoveWorkSchedule,
    handleAddDraftScheduleToWorkSchedules,
    isDraftCreating,
  } = useWorkScheduleCalendarContext();

  const handleClose = () => {
    setDraftAnchorEl(null);
    handleRemoveWorkSchedule(data.id);
  };

  const isOpen = !isDraftCreating && !!draftAnchorEl;

  return (
    <>
      <AppointmentContent
        data={data}
        durationType={durationType}
        isDraftSchedule
      />
      <Popover
        sx={{ '& .MuiPaper-root': { width: '38rem' } }}
        open={isOpen}
        anchorEl={draftAnchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <WorkScheduleRangesForm
          handleCloseModal={handleClose}
          onSubmit={handleAddDraftScheduleToWorkSchedules}
          data={data}
          type={FormTypes.add}
          onDelete={handleClose}
        />
      </Popover>
    </>
  );
}
